<script>


import Contact from "@/views/customer/detail/contact";
import Contract from "@/views/customer/detail/contract";
import AccountList from "../components/account-list.vue";
import uploadAvatar from "@/views/widgets/upload-files/upload-avatar";
import DatePickr from "@/views/widgets/date-pickr";
import {customerDetail, getCompanyInfo, patchCustomer} from "@/service";
import {CUSTOMER_INDUSTRY_LIST, CUSTOME_ATTR_LIST, COMPANY_SIZE_TXT, COMPANY_SIZE, LEVEL_ATTR_LIST} from "@/config/common";
import {successMsg, alertError} from "@/helpers/swal";
import LocationSelect from "@/views/widgets/location-select";
import {isValidEmail} from "@/helpers/common";
import i18n from "@/i18n";
import {email, required} from "@vuelidate/validators";
import {useVuelidate} from "@vuelidate/core";

export default {
  setup: () => ({ v$: useVuelidate() }),

  props: {
    source: {
      type: String,
      default: "business-partner", // 来源：business-partner 从商业伙伴过来  user-center: 从用户中心过来
    },
    // 企业账户权限code，有此权限才能查看企业账户
    accountPermissionCode: {
      type: String,
      default: "",
    },
    // 企业账户编辑权限code, 有此权限才能编辑企业账户
    accountEditPermissionCode: {
      type: String,
      default: "",
    },
    // 其余信息查看权限code，有此权限才能查看其余信息
    otherPermissionCode: {
      type: String,
      default: "",
    },
    // 其余信息编辑权限code，有此权限才能编辑其余信息
    otherEditPermissionCode: {
      type: String,
      default: "",
    },
    customerId: {
      type: [String, Number],
      default: null
    },
  },

  data() {
    return {
      CUSTOME_ATTR_LIST,
      INDUSTRY: CUSTOMER_INDUSTRY_LIST,
      COMPANY_SIZE_TXT,
      COMPANY_SIZE,
      title: i18n.global.t('page.customer'),
      checkTabVal: '',
      serviceCompany: {
        logo: '',
        name: '',
        introduce: '',
        industry: '',
        tel: '',
        email: '',
        home_url: '',
        address: '',
        build_at: '',
        size: '',
        attribute: '',
        code: '',
      },
      companyEditing: false,
      notLoadContactList: false,
      LEVEL_ATTR_LIST
    };
  },
  validations: {
    serviceCompany: {
      name: { required },
      attribute: { required },
      address: { required },
      email: { email },
    }
  },
  components: {
    Contact,
    Contract,
    uploadAvatar,
    DatePickr,
    LocationSelect,
    Account :AccountList,
  },
  computed: {
    tabOptions() {
      const options = []
      if (this.hasPermissionFor(this.otherPermissionCode)) {
        options.push({
          value: '1',
          text: this.$t('page.business-partner.procurementContact')
        })
        options.push({
          value: '2',
          text: this.$t('page.business-partner.contract')
        })
      }
      if (this.hasPermissionFor(this.accountPermissionCode) && this.source !== 'user-center') {
        options.push({
          value: '3',
          text: this.$t('page.business-account')
        })
      }
      return options
    }
  },
  watch: {

  },
  mounted() {
    this.getDetail()
    // 从设备全生命周期过来时,有合同详情，选中合同选项卡，并打开合同详情弹窗
    const contractDetail = localStorage.getItem('contractDetail')
    if (contractDetail) {
      this.notLoadContactList = true
      this.checkTabVal = '2'
      this.$nextTick(() => {
        this.$refs.contract.showDetail(JSON.parse(contractDetail))
      })
      localStorage.removeItem('contractDetail')
    }else{
      // 默认选中第一项
      let val = this.tabOptions[0]?.value || ''
      val && this.switchTab(val)
    }
  },

  methods: {
    getDetail() {
      if (this.source === 'user-center') {
        getCompanyInfo().then(res => {
          this.serviceCompany = res.payload
        })
        return
      }
      customerDetail(this.customerId).then(res => {
        this.serviceCompany = res.payload
      })
    },
    editServiceCompany() {
      this.companyEditing = true
    },
    // 修改选择地区后
    locationSelected(selected) {
      if (selected) {
        this.serviceCompany.country = selected[0]
        this.serviceCompany.province = selected[1]
        this.serviceCompany.city = selected[2]
      } else {
        this.serviceCompany.country = null
        this.serviceCompany.province = null
        this.serviceCompany.city = null
      }
    },
    async saveServiceCompany() {
      this.v$.serviceCompany.$touch()
      // const result = await this.v$.$validate()
      // if (!this.form.logo) {
      //   alertError('提示', '请上传logo！')
      //   return
      // }
      // console.log(this.serviceCompany,result,this.v$)
      for (let i = 0; i < this.v$.serviceCompany.email.$errors.length; i++) {
        if (this.v$.serviceCompany.email.$errors[i].$message == 'Value is not a valid email address') {
          alertError(this.$t('base.prompt'), this.$t('page.wrongEmailFormat'))
          return
        }
      }
      // if (!result) {
      //   alertError(this.$t('base.prompt'), this.$t('page.pleaseCompleteTheRequiredInformation'))
      //   return
      // }
      if(this.serviceCompany.attribute==='KA'&&!this.serviceCompany.ka_level){
        alertError(this.$t('base.prompt'), this.$t('page.pleaseCompleteTheRequiredInformation'))
        return
      }
      if (this.serviceCompany.email && !isValidEmail(this.serviceCompany.email)) {
        alertError(this.$t('base.prompt'), this.$t('manufacturer.email-error'))
        return
      }
      patchCustomer(this.serviceCompany).then(() => {
        successMsg(this.$t('base.modified_successfully'))
        this.companyEditing = false
        this.getDetail()
      }).catch(err => {
        console.log(err)
        alertError(this.$t('base.prompt'), this.$t('manufacturer.error'))
      })
    },
    cancelEditing() {
      this.companyEditing = false

      this.getDetail()
    },
    switchTab(val) {
      this.checkTabVal = val
      this.notLoadContactList = false
    },
  },
};
</script>

<template>
  <div>
    <b-row align-v="stretch">
      <b-col cols="9">
        <b-card no-body class="mb-0 border-bottom">
          <b-card-header class="border-0">
            <ul class="nav nav-tabs-custom card-header-tabs border-bottom-0" role="tablist">
              <li class="nav-item" v-for="(item, index) in tabOptions" :key="index" @click="switchTab(item.value)">
                <b-link class="nav-link fw-semibold" :class="item.value == checkTabVal ? 'active' : ''" role="tab">
                  {{ item.text }}
                </b-link>
              </li>
            </ul>
          </b-card-header>
        </b-card>
        <Contact v-if="checkTabVal == '1'" :get-permission-code="otherPermissionCode" :edit-permission-code="otherEditPermissionCode"></Contact>
        <Contract ref="contract" v-if="checkTabVal == '2'" :customer-name="serviceCompany.name" :edit-permission-code="otherEditPermissionCode" :init-load="!notLoadContactList"></Contract>
        <Account
            v-if="checkTabVal == '3' && customerId"
            type="organization"
            :belong_id="customerId"
            belong_type="customer"
            :get-permission-code="accountPermissionCode"
            :patch-permission-code="accountEditPermissionCode"
            :post-permission-code="accountEditPermissionCode"
            :freeze-permission-code="accountEditPermissionCode"
            :reset-permission-code="accountEditPermissionCode"
            @addOrUpdated="getDetail"
        ></Account>
      </b-col>
      <b-col cols="3" v-perm="otherPermissionCode">
        <b-card no-body class="mb-0">
          <b-card-body class="p-4">
            <div>
              <div class="d-flex justify-content-end btns-wrapper">
                <div v-if="companyEditing" class="avatar-sm circle-btn">
                  <div class="avatar-title rounded-circle bg-body text-primary cursor-pointer" @click="saveServiceCompany">
                    <i class="ri-check-line"></i>
                  </div>
                </div>
                <div v-if="!companyEditing" class="avatar-sm circle-btn" @click="editServiceCompany" v-perm="otherEditPermissionCode">
                  <div class="avatar-title rounded-circle bg-body text-primary cursor-pointer">
                    <i class="ri-edit-2-line"></i>
                  </div>
                </div>
              </div>
              <div class="flex-shrink-0 avatar-md mx-auto mt-3">
                <upload-avatar :value="serviceCompany.logo" :upload-disable="!companyEditing" v-model="serviceCompany.logo" input-id="uploadCompanyLogo" filename-prefix="sc" return-type="url"></upload-avatar>
              </div>
              <div class="mt-4 text-center">
                <h5 class="mb-1" v-if="!companyEditing">{{ serviceCompany.name }}</h5>
                <input v-else type="text" :class="v$.serviceCompany.name.$errors.length ? 'is-invalid' : ''" class="form-control" v-model="serviceCompany.name" @blur="v$.serviceCompany.name.$touch()" required/>
              </div>
              <div class="mt-4">
                <span class="fw-medium">{{this.$t('page.companyIntroduction')}}</span>
                <p class="mt-2" v-if="!companyEditing">{{ serviceCompany.introduce }}</p>
                <textarea v-else class="form-control mt-2" rows="6" v-model="serviceCompany.introduce"></textarea>
              </div>
              <div class="table-responsive">
                <table class="table mb-0 table-borderless">
                  <tbody>
                  <tr>
                    <th :class="!companyEditing?'min-w-90':''"><span class="fw-medium">{{this.$t('page.industry')}}</span></th>
                    <td>
                      <span v-if="!companyEditing">{{ serviceCompany.industry?$t(`overview_dynamic.industy_dict['${serviceCompany.industry}']`):"-" }}</span>
                      <Multiselect
                          v-else
                          class="form-control"
                          :can-clear="false"
                          :can-deselect="false"
                          v-model="serviceCompany.industry"
                          :close-on-select="true"
                          :searchable="true"
                          :create-option="false"
                          :placeholder="this.$t('page.select-industry')"
                          :options="INDUSTRY"
                      />
                    </td>
                  </tr>
                  <tr v-if="!companyEditing && source === 'business-partner'">
                    <th class="min-w-90"><span class="fw-medium">{{this.$t('page.registerStatus')}}</span></th>
                    <td>
                      <span>{{ serviceCompany.register_status ? this.$t('page.registered') : this.$t('page.unregistered') }}</span>
                    </td>
                  </tr>
                  <tr>
                    <th :class="!companyEditing?'min-w-90':''"><span class="fw-medium">{{this.$t('base.attribute')}}</span><span v-if="companyEditing" class="text-danger">{{this.$t('serviceCompany.not_null')}}</span></th>
                    <td>
                      <span v-if="!companyEditing">{{ serviceCompany.attribute?$t(`${serviceCompany.attribute}`):"-" }}</span>
                      <Multiselect
                          v-else
                          class="form-control"
                          :class="v$.serviceCompany.attribute.$errors.length ? 'is-invalid' : ''"
                          :can-clear="false"
                          :can-deselect="false"
                          v-model="serviceCompany.attribute"
                          :close-on-select="true"
                          :searchable="true"
                          :create-option="false"
                          :placeholder="this.$t('page.PleaseSelectProperties')"
                          :options="CUSTOME_ATTR_LIST"
                      />
                    </td>
                  </tr>
                  <tr v-if="serviceCompany.attribute == 'KA'">
                    <th :class="!companyEditing?'min-w-90':''"><span class="fw-medium">{{  $t("KA客户类型") }}</span><span v-if="serviceCompany.attribute==='KA'&&companyEditing" class="text-danger">{{this.$t('serviceCompany.not_null')}}</span></th>
                    <td>
                      <span v-if="!companyEditing">{{ serviceCompany.ka_level }}</span>
                      <Multiselect
                          v-else
                          class="form-control"
                          :class="serviceCompany.attribute==='KA'&&!serviceCompany.ka_level ? 'is-invalid' : ''"

                          :can-clear="false"
                          :can-deselect="false"
                          v-model="serviceCompany.ka_level"
                          :close-on-select="true"
                          :searchable="true"
                          :create-option="false"
                          :placeholder="this.$t('page.PleaseSelectProperties')"
                          :options="LEVEL_ATTR_LIST"
                      />
                    </td>
                  </tr>
                  <tr>
                    <th><span class="fw-medium">{{this.$t('page.customer-attr.code')}}</span></th>
                    <td>
                      <span v-if="!companyEditing">{{ serviceCompany.code }}</span>
                      <input v-else type="text" class="form-control" v-model="serviceCompany.code" />
                    </td>
                  </tr>
                  <tr>
                    <th><span class="fw-medium">{{this.$t('page.contact_number')}}</span></th>
                    <td>
                      <span v-if="!companyEditing">{{ serviceCompany.tel }}</span>
                      <input v-else type="text" class="form-control" v-model="serviceCompany.tel" />
                    </td>
                  </tr>
                  <tr>
                    <th><span class="fw-medium">{{this.$t('page.email')}}</span></th>
                    <td>
                      <span v-if="!companyEditing">{{ serviceCompany.email }}</span>
                      <input v-else type="text" :class="v$.serviceCompany.email.$errors.length ? 'is-invalid' : ''" class="form-control" v-model="serviceCompany.email" />
                    </td>
                  </tr>
                  <tr>
                    <th><span class="fw-medium">{{this.$t('page.homepage')}}</span></th>
                    <td>
                      <span v-if="!companyEditing">{{ serviceCompany.home_url }}</span>
<!--                      <b-link v-if="!companyEditing" target="_blank" :href="serviceCompany.home_url" class="link-primary">{{ serviceCompany.home_url }}</b-link>-->
                      <input v-else type="text" class="form-control" v-model="serviceCompany.home_url" />
                    </td>
                  </tr>
                  <tr>
                    <th><span class="fw-medium">{{this.$t('page.company_address')}}</span><span v-if="companyEditing" class="text-danger">{{this.$t('serviceCompany.not_null')}}</span></th>
                    <td>
                      <div v-if="!companyEditing">
                        {{ serviceCompany.country_txt }}{{ serviceCompany.province_txt }}{{ serviceCompany.city_txt }}{{ serviceCompany.address }}
                      </div>
                      <template v-else>
                        <location-select
                            :selected-location="[serviceCompany.country, serviceCompany.province, serviceCompany.city]"
                            @selected="locationSelected"
                        ></location-select>
                        <input type="text" class="form-control" :class="v$.serviceCompany.address.$errors.length ? 'is-invalid' : ''" v-model="serviceCompany.address" />
                      </template>

                    </td>
                  </tr>
                  <tr>
                    <th><span class="fw-medium">{{this.$t('page.establishedTime')}}</span></th>
                    <td>
                      <span v-if="!companyEditing">
                        {{ serviceCompany.build_at }}
                      </span>
                      <DatePickr v-else :value="serviceCompany.build_at" v-model="serviceCompany.build_at" />
                    </td>
                  </tr>
                  <tr>
                    <th><span class="fw-medium">{{this.$t('page.companySize')}}</span></th>
                    <td>
                      <span v-if="!companyEditing">
                        {{ COMPANY_SIZE_TXT[serviceCompany.size] }}
                      </span>
                      <Multiselect
                          v-else
                          class="form-control"
                          :can-clear="false"
                          :can-deselect="false"
                          v-model="serviceCompany.size"
                          :close-on-select="true"
                          :searchable="true"
                          :create-option="false"
                          :placeholder="this.$t('page.please-select-company-size')"
                          :options="COMPANY_SIZE"
                      />
                    </td>
                  </tr>
                  </tbody>
                </table>
                <div v-if="companyEditing" class="d-flex justify-content-end">
                  <button class="btn btn-light me-4 px-4" @click="cancelEditing">{{this.$t('base.cancel')}}</button>
                  <button class="btn btn-primary px-4" @click="saveServiceCompany">{{this.$t('base.done')}}</button>
                </div>
              </div>
            </div>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
  </div>

</template>
<style scoped>
.btns-wrapper {
  position: absolute;
  top: 10px;
  right: 10px;
}
.circle-btn {
  width: 2.5rem;
  height: 2.5rem;
  font-size: 1.4rem;
}
</style>
